<template>
    <ui-Airboard panel="ubication" v-if="location" :loading="loading">
        <template v-slot:menuBar>
            <div class="icoButton" data-icoTarget="left" @click.stop.prevent="goDashboard"></div>
            <RefreshIco></RefreshIco>
            <ConfigPanelMixinMenu></ConfigPanelMixinMenu>
        </template>
        <template v-slot:head>
            <div class="name__back">{{ location.name || $dicc.locations.default }}</div>
            <div class="name">{{ location.name || $dicc.locations.default }}</div>
        </template>
        <template v-slot:body>
            <div class="filter" v-if="spaces.length > 1 || location.chars.length > 1">
                <template class="col-12" v-if="spaces.length > 1">
                    <p class="titleSection">{{ $dicc.spaces.title }}</p>
                    <div class="scrollArea">
                        <ui-IcoBtn
                            v-for="space in spaces"
                            :key="space.id"
                            :button="true"
                            :valueIco="$class.space[space.type]"
                            :label="space.name || $dicc.spaces.default"
                            :active="filtersSpaces.includes(space.id)"
                            @click="$fns.arrayAddRemove(filtersSpaces, space.id)"
                        ></ui-IcoBtn>
                    </div>
                </template>
                <template class="col-12" v-if="location.chars.length > 1">
                    <p class="titleSection">{{ $dicc.locations.installations }}</p>
                    <div class="scrollArea">
                        <ui-IcoBtn
                            v-for="char in location.chars"
                            :key="char"
                            valueIco="installation-zones"
                            :label="char"
                        ></ui-IcoBtn>
                    </div>
                </template>
            </div>
            <div class="scrollArea">
                <div class="installation-wrap">
                    <Installation
                        v-for="installation in $fns.sortByProperty(installations, 'name')"
                        :key="installation.reference"
                        :installation="installation"
                        :hidden="isHidden(installation)"
                        :ref="'installation_' + installation.reference"
                        :filtersSpaces="filtersSpaces"
                        :show="$fns.any(openInstallations, installation.reference)"
                        @update:show="$fns.arrayAddRemove(openInstallations, installation.reference)"
                        @deviceClick="openDevicePanel($event)"
                        @actionClick="openSettingsInstallationPanel(installation)"
                    >
                    </Installation>
                </div>
            </div>
        </template>
        <template v-slot:panels>
            <ConfigPanelMixinPanels @updateSpace="init()" @updateLocation="init()"> </ConfigPanelMixinPanels>
            <DevicePanelMixinPanel @updateDevice="init()"></DevicePanelMixinPanel>
            <SettingsInstallationPanelMixinPanel @updateInstallation="init()"></SettingsInstallationPanelMixinPanel>
        </template>
    </ui-Airboard>
</template>

<script>
    import Installation from '../components/Installation';
    import { ViewMixin } from '../mixins/ViewMixin';
    import { ConfigPanelMixin } from '../mixins/ConfigPanelMixin';
    import { DevicePanelMixin } from '../mixins/DevicePanelMixin';
    import { SettingsInstallationPanelMixin } from '../mixins/SettingsInstallationPanelMixin';
    import { mapState } from 'vuex';

    export default {
        name: 'Location',
        components: { Installation },
        mixins: [ViewMixin, ConfigPanelMixin, DevicePanelMixin, SettingsInstallationPanelMixin],
        data() {
            return {
                installations: [],
                filtersSpaces: [],
                filtersTypes: [],
                openInstallations: [],
                openDevice: null,
            };
        },
        mounted() {
            this.$onInstance('refresh', () => {
                this.init(
                    () => this.$emitInstance('startRefresh'),
                    () => this.$emitInstance('endRefresh')
                );
            });
            this.init();
        },
        methods: {
            init(callbackStart, callbackEND) {
                // this.location = this.$route.params.location;
                // if (this.location === undefined || this.location === null)
                this.getLocation(callbackStart, callbackEND);
                this.getSpaces(callbackStart, callbackEND);
                this.getInstallations(callbackStart, callbackEND);
            },
            goDashboard() {
                this.$router.push({ name: 'Dashboard' });
            },

            getLocation(callbackStart, callbackEND) {
                if (callbackStart) callbackStart();
                this.$api.getLocation(
                    this.$route.params.id,
                    (data) => {
                        this.$store.commit('clearLocations');
                        this.$store.commit('addLocation', {
                            [data.entity.id]: data.entity,
                        });
                    },
                    (error) => {
                        if (error.status == 403) this.goDashboard();
                    },
                    callbackEND
                );
            },

            getSpaces(callbackStart, callbackEND) {
                if (callbackStart) callbackStart();
                this.$api.getSpaces(
                    this.$route.params.id,
                    null,
                    (data) => {
                        this.$store.commit('clearSpaces');
                        data.entity.forEach((x) => {
                            this.$store.commit('addSpace', {
                                [x.id]: x,
                            });
                        });
                    },
                    null,
                    callbackEND
                );
            },

            getInstallations(callbackStart, callbackEND) {
                if (callbackStart) callbackStart();
                this.$api.getInstallations(
                    this.$route.params.id,
                    (data) => {
                        this.installations = data.entity;
                    },
                    null,
                    callbackEND
                );
            },

            isHidden(installation) {
                if (this.filtersTypes.length > 0 && !this.$fns.any(this.filtersTypes, installation.type)) return true;

                if (!this.filtersSpaces.length > 0) return false;

                return false;
            },

            isShowInstallation(installation) {
                return this.$fns.any(this.openInstallations, installation.reference);
            },

            showInstallation(installation) {
                this.$fns.arrayAddRemove(this.openInstallations, installation.reference);
            },

            isShowDevice() {
                return this.openDevice != null;
            },
        },
        computed: {
            ...mapState({
                location(state) {
                    return state.locations[this.$route.params.id];
                },
                spaces(state) {
                    return Object.values(state.spaces) || [];
                },
            }),
        },
    };
</script>
